module.exports = __webpack_public_path__ + "images/chuck_logo_white.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chuck_logo_white.svg
// module id = 519
// module chunks = 0